import React from 'react';
import qs from 'qs';
import objectPath from 'object-path';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Spinner } from './ui-react';
import ConfirmModal from './ConfirmModal';
import AlertMessage from './AlertMessage';
import QuickSearch from './QuickSearch';
import AdvancedFilters from './AdvancedFilters';
import ListingFilters from './ListingFilters';
import ListingPagination from './ListingPagination';

class ListingObjects extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickDelete = this.handleClickDelete.bind(this);
    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    this.handleClickAdvancedFilters = this.handleClickAdvancedFilters.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.state = {
      objectToDelete: null
    };
    this.i18n = { t: (str) => str };
  }
  componentDidMount() {
    if (this.context.i18n) this.i18n = this.context.i18n;
    if (!this.props.initialAdvancedFilters) {
      this.refreshListingFromUrl(this.props);
    } else {
      const advancedFilters = { ...this.props.initialAdvancedFilters };
      const props = { ...this.props, advancedFilters };
      const query = this.getQueryParamsFromUrl(props);
      if (query.advanced) props.useAdvancedFilters = true;
      this.refreshListingFromUrl(props);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.refreshListingFromUrl(nextProps);
    }
    if (nextProps.deleteSuccessful) {
      this.refreshListingFromUrl(nextProps);
    }
  }
  componentWillUnmount() {
    if (this.props.onLeaveListing) this.props.onLeaveListing();
  }

  render() {
    const objects = this.props.objects[this.props.collectionName];
    const filterBoxClassname = 'box box-info ' + (this.props.useAdvancedFilters ?
      'FilterBox FilterBox-open' : 'FilterBox FilterBox-closed');
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row form-inline">
            <div className="col-md-3">
              <h3 className="box-title">
                { this.props.title }&nbsp;
                {
                  this.props.onNew
                    ? <button type="button" className="btn btn-sm btn-primary" onClick={ this.props.onNew }>{ this.i18n.t('Create') }</button>
                    : null
                }
                {
                  this.props.onClickCsv
                    ? <button type="button" className="btn btn-sm btn-info" onClick={ this.props.onClickCsv }>{ this.i18n.t('CSV') }</button>
                    : null
                }
                {
                  this.props.onBatchPrint
                    ? <button type="button" className="btn btn-sm btn-info" onClick={ this.props.onBatchPrint }>{ this.i18n.t('Print') }</button>
                    : null
                }
              </h3>
            </div>
            <div className="col-md-4">
              {
                this.props.filters
                  ? <ListingFilters
                      label={ this.i18n.t('Display') }
                      filters={ (this.props.filters).map(f => ({ ...f, label: this.i18n.t(f.label || f.value) })) }
                      selectedFilter={ this.props.selectedFilter }
                      canSelectAll={ this.props.canSelectAll }
                      onChange={ this.handleChangeListingParams.bind(this, 'filter') }
                    />
                  : null
              }
            </div>
            <div className="col-md-2">
              {
                this.props.useQuickSearch
                  ? <QuickSearch
                      placeholder={ this.i18n.t('Search') }
                      searchKeyword={ this.props.searchKeyword }
                      initialized={ this._listingReady }
                      onSearch={ this.handleChangeListingParams.bind(this, 'search') }
                    />
                  : null
              }
            </div>
            <div className="col-md-2">
              {
                this.props.advancedFilters
                  ? <button type="button" className="btn btn-info btn-sm" onClick={ this.handleClickAdvancedFilters }>
                      { !this.props.useAdvancedFilters ? this.i18n.t('Show advanced filters') : this.i18n.t('Hide advanced filters') }
                    </button>
                  : null
              }
            </div>
            <div className="col-md-1">
              <button type="button" className="btn btn-info margin-bottom" title="Refresh" onClick={ this.refreshListingFromUrl.bind(this, this.props) }>
                <i className="fa fa-sync"></i>
              </button>
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          {
            this.props.successMessage
              ? <AlertMessage
                  type="success"
                  onDismiss={ this.props.onDismissAlert }>
                    { this.props.successMessage }
                </AlertMessage>
              : null
          }
          {
            this.props.errorMessage
              ? <AlertMessage
                  type="error"
                  onDismiss={ this.props.onDismissAlert }>
                    { this.props.errorMessage }
                </AlertMessage>
              : null
          }
          {
            this.props.advancedFilters
              ? <div className={filterBoxClassname}>
                  <div className="box-header">
                    <span className="box-title">{ this.i18n.t('Advanced filters') }</span>
                  </div>
                  <div className="box-body">
                    <AdvancedFilters
                      { ...this.props }
                      advancedFilters={ this.props.advancedFilters }
                      initialized={ this._listingReady }
                      onSearch={ this.handleChangeListingParams.bind(this, 'advancedFilters') } />
                  </div>
                </div>
              : null
          }
          <div className="box box-primary">
            <Spinner show={this.props.loading} />
            <div className="box-body row">
              <div className="col-xs-12">
                <div className="table-responsive no-padding">
                  <table className="table table-hover table-striped table-bordered table-responsive">
                    <thead>
                      <tr>
                        {
                          this.displayColumns(this.props.columns).map(this.renderHeader)
                        }
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        (objects || []).map((object, i) => {
                          const canEdit = typeof this.props.canEdit === 'function'
                            ? this.props.canEdit(object)
                            : this.props.canEdit;
                          const canDelete = typeof this.props.canDelete === 'function'
                            ? this.props.canDelete(object)
                            : this.props.canDelete;
                          const canShow = typeof this.props.canShow === 'function'
                            ? this.props.canShow(object)
                            : this.props.canShow;
                          return (
                            <tr key={i}>
                              {
                                this.displayColumns(this.props.columns).map((column, j) => {
                                  let value;
                                  if (column.value) {
                                    value = column.value(object);
                                  } else {
                                    value = this.getValue(object, column.attribute);
                                  }
                                  return <td key={j}>{ value }</td>;
                                })
                              }
                              <td>
                                <div>
                                  <DropdownButton title={ <span><i className="fa fa-caret" /> {this.i18n.t('Actions')}</span> } pullRight bsSize="small" id="Menu actions">
                                    {
                                      canShow && this.props.onShow
                                        ? <MenuItem onClick={ this.props.onShow.bind(this, object) }>
                                            <i className="fas fa-eye fa-fw" /> { this.i18n.t('Show') }
                                          </MenuItem>
                                        : null
                                    }
                                    {
                                      canEdit && this.props.onEdit
                                        ? <MenuItem onClick={ this.props.onEdit.bind(this, object) }>
                                            <i className="fas fa-edit fa-fw"/> { this.i18n.t('Edit') }
                                          </MenuItem>
                                        : null
                                    }
                                    {
                                      canDelete && this.props.onDelete
                                        ? <MenuItem onClick={ this.handleClickDelete.bind(this, object) }>
                                            <i className="fas fa-trash fa-fw" /> { this.i18n.t('Delete') }
                                          </MenuItem>
                                        : null
                                    }
                                    {
                                      (this.props.actions || []).map((action, j) => {
                                        if (!action.hasOwnProperty('display') || action.display(object)) {
                                          return (
                                            <MenuItem key={ j } onClick={ this.props.onClickAction.bind(this, object, action.name) }>
                                              { action.icon ? <i className={ action.icon } /> : null } { this.i18n.t(action.label || action.name) }
                                            </MenuItem>
                                          );
                                        }
                                        return null;
                                      })
                                    }
                                  </DropdownButton>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                  <ListingPagination
                    page={ this.props.page }
                    totalPages={ this.props.totalPages }
                    onPageChange={ this.handleChangeListingParams.bind(this, 'page') }
                    hidePagination={ this.props.hidePagination } />
                </div>
              </div>
            </div>
          </div>
          <ConfirmModal
            show={ !!this.state.objectToDelete }
            onClose={ this.handleCancelDelete }
            title={ this.i18n.t('Delete') }
            disabled={ this.props.loading }
            onConfirm={ this.handleConfirmDelete }
            labelConfirm={ this.i18n.t('Delete') }
            labelCancel={ this.i18n.t('Cancel') }>
              {
                this.props.deleteMessage
                  ? this.props.deleteMessage
                  : <span>{ this.i18n.t('Are you sure you want to delete this object ?') }</span>
              }
          </ConfirmModal>
        </section>
      </div>
    );
  }

  getQueryParamsFromUrl(props) {
    return props.location.search
      ? qs.parse(props.location.search.split('?')[1])
      : {};
  }
  refreshListingFromUrl(props) {
    this._listingReady = false;
    const query = this.getQueryParamsFromUrl(props);
    const searchKeyword = query.search;
    const selectedFilter = query.filter || props.defaultFilter;
    const useAdvancedFilters = props.useAdvancedFilters;
    const advancedFilters = this.getUpdatedAdvancedFilters(props.advancedFilters, query.advanced);
    const page = query.page;
    const sort = query.sort ? query.sort.split('__') : props.defaultSort;
    this.props.fetchListing({ searchKeyword, selectedFilter, useAdvancedFilters, advancedFilters, page, sort })
      .then(() => this._listingReady = true);
  }

  getUpdatedAdvancedFilters(advancedFilters, queryParams) {
    if (!advancedFilters) return null;
    return Object.keys(queryParams || {}).reduce((updatedAdvancedFilters, filterName) => {
      const value = queryParams[filterName];
      const filter = { ...updatedAdvancedFilters[filterName], value };
      return { ...updatedAdvancedFilters, [filterName]: filter };
    }, advancedFilters);
  }

  displayColumns(columns) {
    return (columns || []).filter(column => {
      if (!column.display) return true;
      return column.display(this.props);
    })
  }

  renderHeader(column, i) {
    const attribute = column.attribute;
    const label = column.label ? column.label : column.attribute;
    if (column.sortable || !column.hasOwnProperty('sortable')) {
      const sortingClass = this.props.sort && this.props.sort[0] === attribute
        ? this.props.sort[1]
        : '';
      let sortingIconClass = 'fa fa-arrows-alt-v';
      if (sortingClass === 'asc') sortingIconClass = 'fa fa-long-arrow-alt-up';
      if (sortingClass === 'desc') sortingIconClass = 'fa fa-long-arrow-alt-down';
      return (
        <th key={i} className={ `sorting ${sortingClass}`} onClick={ this.handleSort.bind(this, sortingClass, attribute) }>
          { this.i18n.t(label) } <i className={ sortingIconClass }></i>
        </th>
      );
    }
    return (<th key={i}>{ this.i18n.t(label) }</th>);
  }

  handleChangeListingParams(attributeName, value) {
    if (attributeName === 'advancedFilters') {
      let paramString = this.convertAdvancedFiltersToQueryString(value);
      const currentQueryParams = {
        search: this.props.searchKeyword,
        filter: this.props.selectedFilter,
        page: 1,
        sort: this.props.sort ? this.props.sort.join('__') : null,
      };
      const otherParams = qs.stringify(currentQueryParams, { encode: false, skipNulls: true });
      if (otherParams) paramString += '&' + otherParams;
      this.props.router.push({ pathname: this.props.location.pathname, search: paramString });
    } else {
      const page = attributeName !== 'page' ? 1 : value;
      const query = { ...this.props.location.query, [attributeName]: value, page };
      this.props.router.push({ ...this.props.location, query });
    }
  }
  handleClickAdvancedFilters() {
    const useAdvancedFilters = !this.props.useAdvancedFilters;
    this.props.onClickAdvancedFilters(useAdvancedFilters);
  }
  handleSort(currentOrder, attribute) {
    const order = currentOrder === 'asc' ? 'desc' : 'asc';
    const param = `${attribute}__${order}`;
    this.handleChangeListingParams('sort', param);
  }

  convertAdvancedFiltersToQueryString(advancedFilters) {
    const advanced = Object.keys(advancedFilters).reduce((result, filterName) => {
      const value = advancedFilters[filterName].value;
      return { ...result, [filterName]: value };
    }, {});
    return '?' + qs.stringify({ advanced }, { encode: false, skipNulls: true });
  }

  getValue(object, attribute, parentPath = null) {
    // Is normal attribute
    if (attribute.indexOf('.') === -1) {
      const value = object[attribute];
      return value && typeof value === 'object' ? value.$i18n[this.props.defaultLanguage] : value; // FIXME and for fieldset ?
    }
    const parts = attribute.split('.');
    const attributeName = parts.shift();
    const value = object[attributeName];
    if (value === null || value === undefined) return '';
    const path = parentPath ? `${parentPath}.${attributeName}` : attributeName;
    // Is relation/reference
    if (value.$type && value.$type === 'reference') {
      const [collectionName, id] = value.value;
      const relatedObject = this.props.objects[collectionName].find(o => o.id === id);
      if (!relatedObject) return '';
      return this.getValue(relatedObject, parts.join('.'), path);
    }
    // Is embedded object
    return this.getValue(value, parts.join('.'), path);
  }

  handleClickDelete(object) {
    this.setState({ objectToDelete: object });
  }
  handleCancelDelete() {
    this.setState({ objectToDelete: null });
  }
  handleConfirmDelete() {
    this.props.onDelete(this.state.objectToDelete, this.props);
    this.setState({ objectToDelete: null });
  }
}

ListingObjects.propTypes = {
  defaultLanguage: React.PropTypes.string,
  loading: React.PropTypes.bool,
  title: React.PropTypes.string,
  urlForNew: React.PropTypes.string,
  columns: React.PropTypes.array,
  collectionName: React.PropTypes.string,
  objects: React.PropTypes.object,
  onEdit: React.PropTypes.func,
  onDelete: React.PropTypes.func,
  successMessage: React.PropTypes.string,
  errorMessage: React.PropTypes.string,
  onDismissAlert: React.PropTypes.func,
};

ListingObjects.contextTypes = {
  i18n: React.PropTypes.object
};

export default ListingObjects;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ListingObjects.jsx